import get from 'lodash/get'
import styled from 'styled-components'
import breakpoint from 'components/breakpoint'

const InputTextView = styled.div`
  padding: 6px 0;
  font-size: ${props => get(props.theme.input, 'textView.fontSize', '16px')};

  ${breakpoint('portrait')`
    font-size: ${props => get(props.theme.input, 'textView.fontSize', '18px')};
    line-height: ${props => get(props.theme.input, 'textView.lineHeight', '24px')};
  `};
`

export default InputTextView
